import { DonationFullDTO, DonationFullDTOClass } from "../dto/DonationFullDTO";

export const personDonationMapper = (dto: DonationFullDTO) => {
  return new DonationFullDTOClass(dto);
};
